/**
 * LavaMenu.js
 *
 * Library for making a menu with an indicator which moves between menu items on mouseover.
 *
 * @version 1.0.0
 * @author Luca Rosaldi <rosaldi@publione.it>
 * @website https://publione.it
 */

var LavaMenu = function () {
  'use strict';

  /**
   * Constructor.
   *
   * @constructor
   * @param {string} selector CSS selector used for the module
   */
  function LavaMenu() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    this.selector = selector;
    this.version = '1.0.0';

    this.initMenu  = this.initMenu.bind( this );
    this.updateIndicator = this.updateIndicator.bind( this );

    this.run();
  }

  /**
   * Transform a camel-cased string to kebab-case.
   *
   * @param  {string} str
   * @return {string}
   */
  LavaMenu.prototype.camelToKebabCase = function( str ) {
    return str.replace( /([A-Z])/g, function( $1 ) { return "-" + $1.toLowerCase(); } );
  };

  /**
   * Implode an object to a CSS string containing all the rules.
   *
   * @param  {object} obj
   * @return {string}
   */
  LavaMenu.prototype.toCSS = function( obj ) {
    var str = '';
    for ( var prop in obj ) str += this.camelToKebabCase( prop ) + ':' + obj[prop] + ';';
    return str;
  };

  /**
   * Create a stylesheet associated to a Menu element.
   *
   * @param {object} element Menu element
   */
  LavaMenu.prototype.createElementStylesheet = function( element ) {
    var style = document.createElement( 'style' );
    style.id = element.id + '-css';
    style.type = 'text/css';
    document.head.appendChild( style );
  };

  /**
   * Get the stylesheet associated to a Menu element.
   *
   * @param  {object}        element Menu element
   * @return {CSSStyleSheet}
   */
  LavaMenu.prototype.getElementStylesheet = function( element ) {
    return document.getElementById( element.id + '-css' ).sheet;
  };

  /**
   * Set CSS rules for an indicator (the ::before pseudo element in the menu).
   *
   * @param {object}  element Menu element
   * @param {object}  rules   Collection of rules to apply
   * @param {integer} index   Where to insert the rules inside the stylesheet
   */
  LavaMenu.prototype.setIndicatorCSS = function( element, rules, index ) {
    index = index || 0;
    var stylesheet  = this.getElementStylesheet( element );
    var ruleset = '#' + element.id + '::before {' + this.toCSS( rules ) + '}';
    if ( stylesheet.cssRules[ index ] ) stylesheet.deleteRule( index );
    return stylesheet.insertRule( ruleset, index );
  };

  /**
   * Update menu indicator.
   *
   * @param  {object} element Menu to update
   * @param  {object} target  Active link inside menu
   */
  LavaMenu.prototype.updateIndicator = function( element, target ) {
    var styles = {
      width:     target.offsetWidth + 'px',
      height:    target.offsetHeight + 'px',
      transform: 'translate(' + target.offsetLeft + 'px,' + target.offsetTop + 'px)'
    };
    this.setIndicatorCSS( element, styles, 1 );
  };

  /**
   * Initialize Menu.
   *
   * @param  {object}  element
   * @param  {integer} index
   */
  LavaMenu.prototype.initMenu = function( element, index ) {

    element.setAttribute( 'id', 'lava-menu-' + ( index + 1 ) );

    this.createElementStylesheet( element );

    // set initial style for the indicator
    var firstLink = element.querySelector( 'a' );
    var rules = {
      width: firstLink.offsetWidth,
      height: firstLink.offsetHeight
    };
    this.setIndicatorCSS( element, rules, 0 );

    var updateIndicator = this.updateIndicator;
    element.addEventListener( 'mouseover', function( e ) {
      if ( e.target.nodeName === 'A' ) updateIndicator( element, e.target );
    });
  };

  /**
   * Initialize Module.
   */
  LavaMenu.prototype.run = function() {
    [].forEach.call( document.querySelectorAll( this.selector ), this.initMenu );
  };

  return LavaMenu;
}();

/**
 * Export function that supports AMD, CommonJS and Plain Browser.
 */
( function ( root, factory ) {
  if ( typeof exports !== 'undefined' ) {
    module.exports = factory;
  } else if ( typeof define === 'function' && define.amd ) {
    define( [], factory );
  } else {
    root.LavaMenu = factory;
  }
})( this || window, LavaMenu );
